import { useEffect, useState } from "react";

const links = [
  { id: "trend", label: "热榜趋势", icon: "ri-fire-line" },
  { id: "news", label: "资讯精选", icon: "ri-news-line" },
  { id: "columns", label: "深度长文", icon: "ri-quill-pen-line" },
  { id: "stars", label: "明星人物", icon: "ri-star-line" },
  { id: "about", label: "关于本站", icon: "ri-information-line" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goAnchor = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-paper-50/95 backdrop-blur shadow-[0_1px_0_0_rgba(36,28,19,0.08)]" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 md:px-6">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5"
          aria-label="明星爆料 首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-crimson-500 text-lg text-white">
            <i className="ri-star-fill" aria-hidden="true"></i>
          </span>
          <span className="font-serif text-xl font-black tracking-wide text-ink-950">
            明星<span className="text-crimson-500">爆料</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => goAnchor(l.id)}
              className="flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-ink-600 transition hover:bg-crimson-50 hover:text-crimson-500"
            >
              <i className={l.icon} aria-hidden="true"></i>
              {l.label}
            </button>
          ))}
        </nav>

        <button
          onClick={() => setOpen(!open)}
          className="flex h-10 w-10 items-center justify-center rounded-full border border-paper-200 bg-paper-50 text-ink-800 lg:hidden"
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-paper-200 bg-paper-50 px-4 py-3 lg:hidden">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => goAnchor(l.id)}
              className="flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-sm font-medium text-ink-800 transition hover:bg-crimson-50 hover:text-crimson-500"
            >
              <i className={`${l.icon} text-crimson-500`} aria-hidden="true"></i>
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}